import { useQuery } from '@tanstack/react-query';

import { bankFeedApi } from 'domain/bankFeed/api';
import { queryOptions } from 'services/query';
import { bankFeedKeys } from './keys';

// Always-fresh: the `allow_connect` flag on a provider can flip to `false` once
// the user adds a connection for that bank in the same session. Cached value
// would show an already-connected bank as still connectable. Same pattern as
// erpAccounts.ts — see that file's comment for the broader rationale.
export const bankFeedProvidersQuery = () =>
  queryOptions({
    queryKey: bankFeedKeys.providers(),
    queryFn: () => bankFeedApi.getProviders(),
    cacheTime: 0,
  });

export const useBankFeedProviders = () => useQuery(bankFeedProvidersQuery());
